// extracted by mini-css-extract-plugin
module.exports = {"svg":"render-svg_svg__gn0gh","coloured":"render-svg_coloured__OyA1_"};